import * as React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HC_exporting from "highcharts/modules/exporting";
import { Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
// import image
import noGraphData from "../../images/noGraphData.png";
HC_exporting(Highcharts);
function BatteryGraph({ loading }) {
  const batteryHistory = useSelector(
    (state) => state.batteryLevels.allBatteryLevels
  );
  const [translation] = useTranslation("translations");
  let my_graph = batteryHistory.type;
  const chartOptions = {
    chart: {
      type: "column",
    },
    credits: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
    title: {
      text: "",
    },
    subtitle: {
      text: "",
    },
    xAxis: {
      categories: batteryHistory.categories,
      crosshair: true,
    },
    yAxis: {
      min: 0,
      max: 100,
      title: {
        text: "Energinivå %",
      },
    },
    tooltip: {
      shared: true,
      useHTML: true,
      formatter: function () {
        const { x, points } = this;
        var content =
          '<strong style="font-size:12px">' + x + "</strong><table>";
        let colNumber = 1;
        let colTitle = "";
        for (const p in points) {
          colTitle = points.length === colNumber ? "Average" : colNumber;
          content +=
            '<tr><td style="color:{series.color};padding:0">' +
            colTitle +
            ":  </td>" +
            '<td style="padding:0"><b>' +
            points[p].y +
            " %</b></td></tr>";
          colNumber++;
        }
        content += "</table>";
        return content;
      },
    },
    plotOptions: {
      column: {
        pointPadding: 0.1,
        borderWidth: 0,
        zones: [
          {
            value: 101,
            color: "#cc9f00",
          },
        ],
      },
      spline: {
        color: "#093846",
        lineWidth: 3,
        states: {
          hover: {
            lineWidth: 4,
          },
        },
        marker: {
          enabled: true,
        },
        dataLabels: {
          enabled: true,
        },
      },
    },
    series: batteryHistory.series,
    exporting: {
      enabled: false,
    },
  };
  return loading ? (
    <div className="d-flex justify-content-center align-items-center">
      <Spinner animation="border" size="sm" style={{ color: "#cc9f00" }} />
    </div>
  ) : batteryHistory.data === null || batteryHistory.data?.length === 0 ? (
    <figure
      className="figure w-100 d-flex justify-content-center"
      style={{ margin: "5rem 0rem" }}
    >
      <div
        className="justify-content-center align-items-center"
        style={{ display: "inline-block", textAlign: "center" }}
      >
        <img src={noGraphData} alt="No-GraphData" style={{ width: "200px" }} />
        <p>{translation("no-graph-data")}</p>
      </div>
    </figure>
  ) : (
    <HighchartsReact
      highcharts={Highcharts}
      options={chartOptions}
      containerProps={{
        className: `battery-graph ${my_graph ? my_graph : ""}`,
      }}
    />
  );
}

export default BatteryGraph;
